import PropTypes from 'prop-types';

import { tariffShape } from 'helpers/shared_types';

const TariffsCard = ({ data }) => {
  if (data.length === 0) return null;

  return (
    <div className="w-100 flex flex-column items-start justify-between">
      <div className="w-100">
        <section className="apps-grid-container th-active-users">
          <span className="apps-grid-title">
            {data.length > 1 ? 'Tariffs' : 'Tariff'}
          </span>
          <div className="apps-grid">
            {data.map((a) => (
              <div key={a.id} className="apps-grid-cell">
                <article className="apps-card-app">
                  <div className="apps-card-left">
                    <div className="apps-card-meta">
                      <h3 className="apps-card-app-title">{a.name}</h3>

                      <p className="apps-card-app-desc">{a.rules}</p>
                    </div>
                  </div>
                  <div className="apps-card-right">
                    <div className="apps-configured">
                      <span className="th-badge">€{a.amount}</span>
                    </div>
                  </div>
                </article>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

TariffsCard.propTypes = {
  data: PropTypes.arrayOf(tariffShape),
};

export default TariffsCard;
